<script setup lang="ts">
import NavBar from '@/components/NavBar.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import SupportModal from '@/components/SupportModal.vue';
import { useAuthStore } from '@/stores/useAuthStore';
import { useThemeStore } from '@/stores/useThemeStore';
import { useSeasonStore } from '@/stores/useSeasonStore';
import { onMounted } from 'vue';
import { useVersionCheck } from '@/composables/useVersionCheck';
import dartsHubApi from '@/axios/dartsHubApi';

const authStore = useAuthStore();
useThemeStore();
const { updateAvailable } = useVersionCheck();
const reloadPage = () => window.location.reload(); // initialise et applique le thème sauvegardé

onMounted(async () => {
  authStore.purgeIfInvalid();
  useSeasonStore().load();

  if (authStore.isAuthenticated) {
    try {
      const { data } = await dartsHubApi.get('/users/me');
      authStore.setAuthData({
        token: authStore.token,
        email: data.email,
        name: data.name,
        firstname: data.firstname,
        nickname: data.nickname || '',
        profile_picture: data.profile_picture || '',
        role: data.role,
        scopes: data.scopes || [],
        userId: data.id,
      });
    } catch {
      // token invalide ou expiré — refreshAccessToken géré par l'interceptor
    }
  }
});
</script>

<template>
  <NavBar v-if="authStore.isAuthenticated && authStore.isSuperAdmin" />
  <RouterView />
  <ConfirmModal />
  <SupportModal />

  <Transition name="slide-up">
    <div v-if="updateAvailable" class="update-banner">
      <span><i class="fa-solid fa-rotate"></i> Une nouvelle version est disponible.</span>
      <button @click="reloadPage">Rafraîchir</button>
    </div>
  </Transition>
</template>

<style scoped>
.update-banner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: var(--primary);
  color: white;
  padding: 1.25rem 2rem;
  border-radius: var(--radius);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
}

.update-banner button {
  background: white;
  color: var(--primary);
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: var(--radius);
  cursor: pointer;
  font-weight: 600;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translate(-50%, calc(-50% + 16px));
}
</style>
